<template>
  <div>
    <v-tabs vertical class="anty-main-tabs mb-2">
      <v-tab to="/overview">
        {{ $t('overview.overview') }}
      </v-tab>
      <v-tab to="/affiliate-program">
        {{ $t('affiliateProgram.affiliateProgram') }}
      </v-tab>
      <v-tab to="/billing">
        {{ $t('billing.billing') }}
      </v-tab>
      <v-tab to="/login-history">
        {{ $t('loginHistory.title') }}
      </v-tab>
      <v-tab to="/api">
        API
      </v-tab>
      <a
        class="main-tabs-faq-url v-tab"
        target="_blank"
        :href="FAQUrl"
      >
        FAQ
      </a>
    </v-tabs>

    <download-section />
  </div>
</template>

<script>

import DownloadSection from "@/components/downloadSection/DownloadSection";
import { mapGetters } from "vuex";

export default {
  name: 'MainTabs',

  components: {
    DownloadSection
  },

  data: () => ({
    faqUrls: {
      ru: 'https://intercom.help/dolphinteam/ru/collections/3947282-dolphin-anty',
      en: 'https://intercom.help/dolphinteam/en/collections/3947282-dolphin-anty'
    }
  }),

  computed: {
    ...mapGetters({
      profile: 'main/profile',
    }),

    FAQUrl () {
      return this.$vuetify.lang.current === 'ru' ? this.faqUrls.ru : this.faqUrls.en
    }
  }
}
</script>

<style scoped>
  .main-tabs-faq-url.v-tab:focus:before {
    background-color: transparent;
  }

  .v-tabs .main-tabs-faq-url.v-tab:hover:focus::before {
    background-color: currentColor;
    opacity: 0.04;
  }
</style>
